<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  let show = false

  export const trigger = (value) => {
    show = value ?? !show
    if (!show) {
      dispatch("close")
    }
  }
</script>

<slot />

{#if show}
  <dialog open class="modal ">
    <form method="dialog">
      <slot name="content" />
      <button class="close-icon flex justify-center rounded-xl w-8 h-8" on:click={() => trigger(false)}> &#10006; </button>
    </form>
  </dialog>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="modal-background" on:click={() => trigger(false)} />
{/if}

<style lang="postcss" scoped>
  .modal {
    @apply bg-white rounded-xl p-8 pr-16;

    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
  }

  .modal-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1;
  }

  .close-icon {
    @apply flex items-center justify-center;
    position: absolute;
    top: 10px;
    right: 10px;
    border: 1px solid lightgray;
  }
</style>
